export const reportConfiguratorFetchMapping: { [index: string]: string } = {
    TABLE: 'lookupValue',
    FUNCTION: 'valueLists',
};

export const switchTabConfirmationLabels = {
    title: 'Предупреждение',
    main: `Вы действительно хотите покинуть форму?
Несохраненные данные будут потеряны.`,
    cancelButtonLabel: 'Нет',
    confirmButtonLabel: 'Да',
};
